const brand = {
  name: process.env.REACT_APP_SITE_NAME || 'Fndix',
  namePart1: process.env.REACT_APP_SITE_NAME_PART1 || 'Fn',
  namePart2: process.env.REACT_APP_SITE_NAME_PART2 || 'dix',
  domain: process.env.REACT_APP_SITE_DOMAIN || 'fndix.com',
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL || 'contact@fndix.com',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@fndix.com',
  legalEmail: process.env.REACT_APP_LEGAL_EMAIL || 'legal@fndix.com',
  description: process.env.REACT_APP_SITE_DESCRIPTION || 'Your trusted source for financial news',
};

export default brand;
